import React, { useEffect, useState } from "react";
import { Col, Form, message, Row } from "antd";
import { SaveButton, CancelButton, ModalComponent, trans, InputDate } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { updateDataReq } from "../requests";
import { Const } from "../../constants";
import dayjs from "dayjs";
import { SelectWithSearch } from '../../../../wrappers/components';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { eoeTooltips } from "../../common/eoeTooltips";
import "./endOfEmploymentModal.css";

const langKey = Const["EOEmployment"].lngKey

const fieldLabel = makeFieldLabel(eoeTooltips.endOfEmployment, { namespace: "endOfEmployment", label: (key) => trans(`${langKey}.${key}`) });
const formName = "updateEndOfEmployment";

const CreateEndOfEmployment = (props) => {
  const [, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [interviewData,setInterviewData]=useState([])
  const [form] = Form.useForm();
  useEffect(() => {
    setData()
    // eslint-disable-next-line
  }, []);
  const setData = () => {
    
    setInterviewData(Array.isArray(props.record.interview_answers) ? props.record.interview_answers : [])
    setEmployee([
      {
        value: props.record.employment_id,
        label: props.record.requestor.full_name_code,
      }])
    form.setFieldsValue({
      last_working_date: props.record.last_working_date ? dayjs(props.record.last_working_date) : null,
      //joining_date: props.record.requestor.joining_date ? dayjs(props.record.requestor.joining_date) : null
    })

  }

  const onSubmit = (data) => {
    setSaveLoader(true)
    data.last_working_date = data.last_working_date ? dayjs(data.last_working_date).format('YYYY-MM-DD') : null;
    data.joining_date = data.joining_date ? dayjs(data.joining_date).format('YYYY-MM-DD') : null;
    data.employment_id = props.record.employment_id;
    data.id = props.record.id;
    const payload = { end_of_employment: data };
    makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCreated(data.end_of_employments.data);
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }



  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    !props.disabled &&
    <SaveButton disabled={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCreated(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 900 } maskClosable={ false } className="eoe-modal"
      mainTitle={ "Rehire" } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCreated(false) }>
      <div className="eoe-modal-content">
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } disabled={ props.disabled } scrollToFirstError>
          <div className="eoe-form-section">
            <h5 className="eoe-form-section-title">Rehire Details</h5>
            <Row gutter={ 24 }>
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="employment_id" rules={ rules.employment_id } label={ fieldLabel("employment_id", trans(`${langKey}.employment_id`)) }
                  { ...getErrorProps(errors['name']) } size="small"
                >
                  <SelectWithSearch
                    disabled
                    defaultValue={ props.record.employment_id }
                    value={ props.record.employment_id }
                    placeholder={ trans(`${langKey}.employment_id`) }
                    options={ employee }
                  />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="last_working_date" rules={ rules.last_working_date } label={ fieldLabel("last_working_date", trans(`${langKey}.last_working_date`)) }
                  { ...getErrorProps(errors['last_working_date']) } size="small"

                >
                  <InputDate />
                </Form.Item>
              </Col>
              { !props.disabled && <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="joining_date" rules={ rules.joining_date } label={ fieldLabel("joining_date", trans(`${langKey}.joining_date`)) }
                  { ...getErrorProps(errors['joining_date']) } size="small"
                >
                  <InputDate />
                </Form.Item>
              </Col> }
            </Row>
          </div>

          { interviewData.length > 0 &&
            <div className="eoe-form-section eoe-interview-section">
              <h5 className="eoe-form-section-title">Exit Interview</h5>
              <div className="eoe-table-wrap">
                <table className="eoe-table eoe-table--read-only">
                  <thead>
                    <tr>
                      <th>Question</th>
                      <th>Answer</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      interviewData.map((each, index) => (

                        <tr key={ each.id || `${each.question_name}-${index}` }>
                          <td>{ each.question_name }</td>
                          <td>{ each.answer }</td>
                        </tr>

                      ))
                    }
                  </tbody>
                </table>
              </div>
            </div>

          }
      </Form>
      </div>

    </ModalComponent>
  )
}

export default CreateEndOfEmployment

const rules = {
  joining_date: [
    { required: true, message: trans(`${langKey}.joining_date.req`) },
  ],


};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
